module.exports = __webpack_public_path__ + "static/img/ls10.ccfd63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls10.png
// module id = AdkB
// module chunks = 12